import { Component, forwardRef, Input, OnInit } from "@angular/core";
import {GestionProjetService} from '../../../../services/gestion-projet/gestion-projet.service';
import {LienTache, TypeLien} from '../../../../models/taches/gestion-taches.model';
import { ControlValueAccessor, UntypedFormControl, NG_VALUE_ACCESSOR } from "@angular/forms";
import {TYPES_LIENS_VISUELS} from '../../../../pages/gestion-taches/data/types-lien-affichage';

@Component({
  selector: 'app-choix-lien',
  templateUrl: './choix-lien.component.html',
  styleUrls: ['./choix-lien.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ChoixLienComponent),
      multi: true,
    },
  ],
})
export class ChoixLienComponent implements OnInit, ControlValueAccessor {

  choixControl: UntypedFormControl = new UntypedFormControl();

  @Input() typeLien: TypeLien;
  @Input() undeletableIds: number[] = [];

  onChange = any => {}

  constructor(public gestionProjetService: GestionProjetService) {
  }

  ngOnInit(): void {
  }

  updateSelection() {
    this.onChange(this.choixControl.value?.map(id => {
      return {idLien: id, typeLien: this.typeLien};
    }))
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
  }

  writeValue(lien: LienTache[]): void {
    this.choixControl.reset(lien?.map(o => o.idLien));
  }

  get iconClass(): string {
    return 'icon icon-' + TYPES_LIENS_VISUELS.find(t => t.typeId == this.typeLien)?.iconClass;
  }
}
